import { useEffect, useState } from "react";

// Counts down to `targetIso` using the server clock offset so the browser clock is never trusted.
export function useCountdown(targetIso, serverNowIso) {
  const [remaining, setRemaining] = useState(null);
  useEffect(() => {
    if (!targetIso || !serverNowIso) return setRemaining(null);
    const offset = new Date(serverNowIso).getTime() - Date.now();
    const tick = () => setRemaining(Math.max(0, new Date(targetIso).getTime() - (Date.now() + offset)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetIso, serverNowIso]);
  return remaining;
}
